module.exports = __webpack_public_path__ + "media/img/frontend_application/usernav-9ee5dce0a9d81684c3ee484fb1e8270a.png";